import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareZ = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler77') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler77', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Btmls bucket!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Btmls bucket!'
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareZ}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareZ
  
